module.exports = __webpack_public_path__ + "img/icon-discord.97c1c101.svg";